document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const list = document.getElementById('product-thumbnails-list');
  const prevBtn = document.getElementById('thumb-prev');
  const nextBtn = document.getElementById('thumb-next');
  const thumbHeight = 80 + 8; // height + gap – ggf. anpassen
  const visibleCount = 4;
  const eagerZone = 2;   // letzte N Thumbnails oben/unten triggern Scroll
  const jumpBy = 1;      // um wie viele Positionen gesprungen wird

  function getCurrentOffset() {
    return Math.round(list.scrollTop / thumbHeight);
  }

  function scrollToOffset(offset) {
    const maxOffset = Math.max(0, thumbnails.length - visibleCount);
    const clamped = Math.max(0, Math.min(offset, maxOffset));
    list.scrollTo({ top: clamped * thumbHeight, behavior: 'smooth' });
  }

function scrollToActive() {
  const index = Array.from(thumbnails).findIndex(t => t.classList.contains('is-active'));
  if (index < 0 || !list) return;

  const offset = getCurrentOffset();
  const visibleEnd = offset + visibleCount - 1;
  const maxOffset = Math.max(0, thumbnails.length - visibleCount);

  // Untere eager zone: nur wenn es noch Thumbnails darunter gibt
  if (index >= visibleEnd - eagerZone + 1 && offset < maxOffset) {
    scrollToOffset(offset + jumpBy);
    return;
  }

  // Obere eager zone: nur wenn es noch Thumbnails darüber gibt
  if (index <= offset + eagerZone - 1 && offset > 0) {
    scrollToOffset(offset - jumpBy);
    return;
  }

  // Mitte: gar nicht scrollen
}


  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      scrollToOffset(getCurrentOffset() - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      scrollToOffset(getCurrentOffset() + 1);
    });
  }

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const targetId = this.dataset.target;

      document.querySelectorAll('.product-images__slide').forEach(function (slide) {
        slide.classList.remove('is-active');
      });
      const targetSlide = document.querySelector('[data-media-id="' + targetId + '"]');
      if (targetSlide) targetSlide.classList.add('is-active');

      thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');

      scrollToActive();
    });
  });

  document.addEventListener('product-slider:change', function (e) {
    const mediaId = e.detail && e.detail.mediaId;
    if (!mediaId) return;
    thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
    const matchingThumb = document.querySelector('.product-thumbnail[data-target="' + mediaId + '"]');
    if (matchingThumb) {
      matchingThumb.classList.add('is-active');
      scrollToActive();
    }
  });
});

// Galerie-Pfeile auf Hauptbild → delegieren an Thumbnail-Nav
document.querySelectorAll('.product-single__media-arrow').forEach(btn => {
  btn.addEventListener('click', function() {
    const isPrev = this.classList.contains('product-single__media-arrow--prev');
    const thumbBtn = document.getElementById(isPrev ? 'thumb-prev' : 'thumb-next');
    if (thumbBtn) thumbBtn.click();
  });
});
